// ContentService.js
import axios from "axios";

const BASE_URL = "https://api.heryerdeingilizce.com/api/admin";

const getHeaders = (token) => ({
    "accept": "*/*",
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
});

// Tüm Kursları Getir
export const getActiveCourses = async (token) => {
    try {
        const response = await axios({
            method: 'GET',
            url: `${BASE_URL}/CourseManager/GetCourses`,
            headers: getHeaders(token)
        });

        if (response.status === 200 && response.data.success) {
            return response.data.data
                .filter(course => !course.isDeleted && course.isActive)
                .map(course => ({
                    id: course.id,
                    courseName: course.name || course.courseName, // API key ismine göre düzenlenebilir
                    courseDesc: course.courseDesc
                }));
        }
        throw new Error(response.data.message || "Kurslar yüklenemedi.");
    } catch (error) {
        throw error;
    }
};

// Tüm Konuları Getir
export const getAllActiveSubjects = async (token) => {
    try {
        const response = await axios({
            method: 'GET',
            url: `${BASE_URL}/SubjectManager/GetList`,
            headers: getHeaders(token)
        });

        if (response.status === 200 && response.data.success) {
            return response.data.data
                .filter(subject => !subject.isDeleted && subject.isActive)
                .map(subject => ({
                    id: subject.id,
                    subjectName: subject.subjectName,
                    subjectDesc: subject.subjectDesc,
                    sortId: subject.sortId
                }));
        }
        throw new Error(response.data.message || "Konular yüklenemedi.");
    } catch (error) {
        throw error;
    }
};

// Belirli bir Kursa Ait Konuları Getir
export const getSubjectsByCourseId = async (courseId, token) => {
    try {
        const response = await axios({
            method: 'GET',
            url: `${BASE_URL}/SubjectManager/GetListByCourse`,
            headers: getHeaders(token),
            params: { id: courseId }
        });

        if (response.status === 200 && response.data.success) {
            return response.data.data.filter(subject => subject.isActive);
        }
        throw new Error(response.data.message || "Kurs konuları yüklenemedi.");
    } catch (error) {
        throw error;
    }
};